import React, { useState, useEffect } from 'react'
import swal from 'sweetalert';
import Select from 'react-select';
import axios from 'axios';

export default function AddAmenities(props) {
    const [items, setitems] = useState({ AmenityName: "", Description: "", UnitId: "", company_id: props.companyid })
    const [addunit, setunit] = useState({})
    const [unitvalue, setunitvalue] = useState()
    // 
    useEffect(() => {
        fetchdata();
    }, [])

    async function fetchdata() {
        const Uniturl = process.env.REACT_APP_APIURL + "FramUnit/GetFramUnits?companyid=" + props.companyid;
        let Unitdata = await axios.get(Uniturl);
        var units = [];
        Unitdata.data.map((u) => {

            units.push({ value: u.unitId, label: u.unitName });
        })
        setunit(units);
    }

    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setitems({ ...items, [name]: value })
    }
    // const [selectitem, setselectitem] = useState(addunit.value);
    const handleSelect = e => {
        const value = e.value;
        // setselectitem(value)
        setunitvalue(e)
        setitems({ ...items, UnitId: value })
    }
    const refresh = () => {
        setitems({ ...items, AmenityName: "", Description: "", UnitId: "", company_id: props.companyid });
        setunitvalue(null)
    }
    const savemethod = async (data) => {
        const url = process.env.REACT_APP_APIURL + "FarmAmenity/AddFarmAmenity";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    //  text: "Once deleted, you will not be able to recover this imaginary file!",
                    icon: "success"
                })
                refresh();

            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        savemethod(items);
    }
    return (
        <div className="row">
            <div className="col-12 col-md-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-0">Add Amenities</h3>
                    </div>
                    <div className="card-body">

                        <div className="basic-form">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="mb-3 col-sm-6">
                                        <label className="form-label">Amenities Name</label>
                                        <input type="text" autoComplete="off" name="AmenityName" value={items.AmenityName} onChange={handleInput} className="form-control" required />
                                    </div>
                                    <div className="mb-3 col-sm-6">
                                        <label className="form-label">Unit</label>
                                        <Select options={addunit} value={unitvalue} onChange={handleSelect} />

                                    </div>
                                    <div className="mb-5 col-12">
                                        <label className="form-label">Description</label>
                                        <textarea className="form-control" name="Description" value={items.Description} onChange={handleInput} ></textarea>
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}